
if (!customElements.get('quick-add-opener')) {
  customElements.define('quick-add-opener', class QuickAddOpener extends HTMLElement {
    connectedCallback () {
      this.addEventListener('click', () => {
        this.show(this.querySelector('button'))
      })
    }

    show (opener) {
      const url = new URL(window.location.origin + opener.getAttribute('data-product-url'))
      url.searchParams.set('view', 'quick-add')

      opener.setAttribute('aria-disabled', true)
      opener.classList.add('loading')

      fetch(url.toString())
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('quick-add-modal')
          document.body.append(responseHTML)
        })
        .catch((error) => {
          console.error(error)
          opener.removeAttribute('aria-disabled')
          opener.classList.remove('loading')
        })
        .finally(() => {
          document.querySelector('quick-add-modal').show(opener)
        })
    }
  })
}

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor () {
      super()
      this.modalImages = this.querySelector('[id^="QuickAddInfo-"] .quick-add-modal__media')
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"] .quick-add-modal__details')
    }

    hide (preventFocus = false) {
      document.body.classList.remove('overflow-hidden', 'quickbuy-open')
      document.body.dispatchEvent(new CustomEvent('modalClosed'))
      this.removeAttribute('open')
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      if (cartNotification) cartNotification.setActiveElement(this.openedBy)
      this.modalContent.innerHTML = ''

      if (preventFocus) this.openedBy = null
      this.remove()
    }

    show (opener) {
      opener.setAttribute('aria-disabled', true)
      opener.classList.add('loading')

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html')
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]')
          this.productImages = responseHTML.querySelector('section.prd-Media .prd-Media_Slides')
          this.preventDuplicatedIDs()
          this.removeDOMElements()
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML)
          this.setInnerHTML(this.modalImages, this.productImages.innerHTML)

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init()
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR()

          this.updateImageSizes()
          this.createSlider()
          this.preventVariantURLSwitching()
          super.show(opener)
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled')
          opener.classList.remove('loading')
          if (window.klaviyoBIS) {
            window.klaviyoBIS()
          }

          setTimeout(() => { this.testForSticky() }, 100)
          window.addEventListener('resize', () => { this.testForSticky() })

          document.body.classList.add('quickbuy-open')
        })
    }

    setInnerHTML (element, html) {
      element.innerHTML = html
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script')
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        })
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      })
    }

    preventVariantURLSwitching () {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects')
      if (!variantPicker) return
      variantPicker.setAttribute('data-update-url', 'false')
    }

    removeDOMElements () {
      const productModal = this.productElement.querySelector('product-modal')
      if (productModal) productModal.remove()
    }

    preventDuplicatedIDs () {
      const sectionId = this.productElement.dataset.section
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`)
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId
      })
    }

    createSlider () {
      function navigation (slider) {
        let dots

        function createDiv (className) {
          const div = document.createElement('div')
          const classNames = className.split(' ')
          classNames.forEach((name) => div.classList.add(name))
          return div
        }

        function dotMarkup () {
          dots = createDiv('dots')
          slider.track.details.slides.forEach((_e, idx) => {
            const dot = createDiv('dot')
            dot.addEventListener('click', () => slider.moveToIdx(idx))
            dots.appendChild(dot)
          })
          document.querySelector('.quick-add-modal__media').prepend(dots)
        }

        function updateClasses () {
          const slide = slider.track.details.rel
          Array.from(dots.children).forEach(function (dot, idx) {
            idx === slide
              ? dot.classList.add('dot--active')
              : dot.classList.remove('dot--active')
          })
        }

        slider.on('created', () => {
          dotMarkup()
          updateClasses()
        })
        slider.on('optionsChanged', () => {
          updateClasses()
        })
        slider.on('slideChanged', () => {
          updateClasses()
        })
      }

      const slider = new window.KeenSlider(
        '.quick-add-modal__media',
        {
          loop: true,
          mode: 'snap',
          slides: {
            perView: 1,
            spacing: 0,
          },
        },
        [
          navigation,
        ],
      )
    }

    updateImageSizes () {
      const product = this.modalImages
      const mediaImages = product.querySelectorAll('.rsp-Image_Image')
      if (!mediaImages.length) return
      const mediaImageSizes = '(max-width: 749px) 100vw, 33vw'
      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes))
    }

    testForSticky () {
      const scrollableDiv = this.querySelector('.quick-add-modal__details')
      const stickyButtons = this.querySelector('.prd-Detail_Block.prd-SizeGuide')
      const buttonsStuck = scrollableDiv.scrollHeight > (scrollableDiv.clientHeight + 2)

      if (buttonsStuck) {
        stickyButtons.classList.add('container-stuck')
      } else {
        stickyButtons.classList.remove('container-stuck')
      }
    }
  })
}
